<template>
  <div v-if="isLoading" class="loading"></div>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
/*
.loading {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2a475a;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin-right: auto;
  margin-left: auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
*/
</style>
